export default "__VITE_ASSET__pqB_6uwc__"